import React, { useState, useEffect } from "react";

const AddressAutoComplete = ({ apiKey, onPlaceSelected }) => {
    const [service, setService] = useState(null);
    const [suggestions, setSuggestions] = useState([]);
    const [inputValue, setInputValue] = useState("");

    useEffect(() => {
        // Ensure Google Maps script is loaded
        if (window.google && window.google.maps && window.google.maps.places) {
            const autocompleteService = new window.google.maps.places.AutocompleteService();
            setService(autocompleteService);
            console.log("Using AutocompleteService (legacy API)");
        } else {
            console.error("Google Maps API not loaded.");
        }
    }, []);

    const handleChange = (e) => {
        const value = e.target.value;
        setInputValue(value);

        if (!service || !value) {
            setSuggestions([]);
            return;
        }
        console.log(service, value)

        service.getPlacePredictions({ input: value }, (results, status) => {
            console.log(results, status)
            if (
                status === window.google.maps.places.PlacesServiceStatus.OK &&
                results
            ) {
                setSuggestions(results);
            } else {
                setSuggestions([]);
            }
        });
    };

    const handleSelect = (suggestion) => {
        setInputValue(suggestion.description);
        setSuggestions([]);
        onPlaceSelected(suggestion);
    };

    return (
        <div className="AddressAutoComplete">
            <input
                type="text"
                value={inputValue}
                onChange={handleChange}
                placeholder="Enter your address"
            />
            {suggestions.length > 0 && (
                <ul className="autocomplete-results">
                    {suggestions.map((s) => (
                        <li key={s.place_id} onClick={() => handleSelect(s)}>
                            {s.description}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default AddressAutoComplete;
